var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { NotifierComponent, SurveyActionBar, ReactElementFactory, ReactQuestionFactory, SurveyElementBase, SurveyLocStringViewer, Survey, SvgBundleComponent, PopupModal } from "survey-react-ui";
import { SurveyCreatorModel, assign } from "survey-creator-core";
import { TabbedMenuComponent } from "./TabbedMenu";
var SurveyCreatorComponent = /** @class */ (function (_super) {
    __extends(SurveyCreatorComponent, _super);
    function SurveyCreatorComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.rootNode = React.createRef();
        return _this;
    }
    Object.defineProperty(SurveyCreatorComponent.prototype, "creator", {
        get: function () {
            return this.props.creator;
        },
        enumerable: false,
        configurable: true
    });
    SurveyCreatorComponent.prototype.getStateElement = function () {
        return this.creator;
    };
    Object.defineProperty(SurveyCreatorComponent.prototype, "style", {
        get: function () {
            return this.props.style;
        },
        enumerable: false,
        configurable: true
    });
    SurveyCreatorComponent.prototype.componentDidUpdate = function (prevProps, prevState) {
        _super.prototype.componentDidUpdate.call(this, prevProps, prevState);
        if (this.creator !== prevProps.creator) {
            if (prevProps.creator) {
                prevProps.creator.unsubscribeRootElement();
            }
            if (this.creator && this.rootNode.current) {
                this.creator.setRootElement(this.rootNode.current);
            }
        }
    };
    SurveyCreatorComponent.prototype.componentDidMount = function () {
        _super.prototype.componentDidMount.call(this);
        this.creator.setRootElement(this.rootNode.current);
    };
    SurveyCreatorComponent.prototype.componentWillUnmount = function () {
        _super.prototype.componentWillUnmount.call(this);
        this.creator.unsubscribeRootElement();
    };
    SurveyCreatorComponent.prototype.renderElement = function () {
        var creator = this.props.creator;
        if (creator.isCreatorDisposed)
            return null;
        var areaClassName = "svc-full-container svc-creator__area svc-flex-column" + (this.props.creator.haveCommercialLicense ? "" : " svc-creator__area--with-banner");
        var contentWrapperClassName = "svc-creator__content-wrapper svc-flex-row" + (this.props.creator.isMobileView ? " svc-creator__content-wrapper--footer-toolbar" : "");
        var fullContainerClassName = "svc-flex-row svc-full-container" + (" svc-creator__side-bar--" + this.creator.sidebarLocation);
        var creatorStyles = {};
        assign(creatorStyles, this.style, this.props.creator.themeVariables);
        var licenseBanner = null;
        if (!this.props.creator.haveCommercialLicense) {
            var htmlValue = { __html: this.props.creator.licenseText };
            licenseBanner = (React.createElement("div", { className: "svc-creator__banner" },
                React.createElement("span", { className: "svc-creator__non-commercial-text", dangerouslySetInnerHTML: htmlValue })));
        }
        //AM: width unrecognized by react
        return (React.createElement("div", { className: this.creator.getRootCss(), ref: this.rootNode, style: creatorStyles },
            React.createElement(SvgBundleComponent, null),
            React.createElement(PopupModal, null),
            React.createElement("div", { className: areaClassName },
                React.createElement("div", { className: fullContainerClassName },
                    React.createElement("div", { className: "svc-flex-column svc-flex-row__element svc-flex-row__element--growing" },
                        React.createElement("div", { className: "svc-top-bar" },
                            (creator.showTabs ?
                                React.createElement("div", { className: "svc-tabbed-menu-wrapper" },
                                    React.createElement(TabbedMenuComponent, { model: creator.tabbedMenu })) : null),
                            (creator.showToolbar ?
                                React.createElement("div", { className: "svc-toolbar-wrapper" },
                                    React.createElement(SurveyActionBar, { model: creator.toolbar }))
                                : null)),
                        React.createElement("div", { className: contentWrapperClassName },
                            React.createElement("div", { className: "svc-creator__content-holder svc-flex-column" }, this.renderActiveTab())),
                        React.createElement("div", { className: "svc-footer-bar" }, (creator.isMobileView ?
                            React.createElement("div", { className: "svc-toolbar-wrapper" },
                                React.createElement(SurveyActionBar, { model: creator.footerToolbar }))
                            : null))),
                    this.renderSidebar()),
                licenseBanner,
                React.createElement(NotifierComponent, { notifier: creator.notifier }))));
    };
    SurveyCreatorComponent.prototype.renderActiveTab = function () {
        var creator = this.props.creator;
        for (var i = 0; i < creator.tabs.length; i++) {
            if (creator.tabs[i].id === creator.activeTab) {
                return this.renderCreatorTab(creator.tabs[i]);
            }
        }
        return null;
    };
    SurveyCreatorComponent.prototype.renderCreatorTab = function (tab) {
        if (tab.visible === false) {
            return null;
        }
        var creator = this.props.creator;
        var component = !!tab.renderTab
            ? tab.renderTab()
            : ReactElementFactory.Instance.createElement(tab.componentContent, {
                creator: creator,
                survey: creator.survey,
                data: tab.data.model
            });
        var className = "svc-creator-tab" + (creator.toolboxLocation == "right" ? " svc-creator__toolbox--right" : "");
        return (React.createElement("div", { role: "tabpanel", key: tab.id, id: "scrollableDiv-" + tab.id, "aria-labelledby": "tab-" + tab.id, className: className }, component));
    };
    SurveyCreatorComponent.prototype.renderSidebar = function () {
        if (!!this.creator.sidebar) {
            return ReactElementFactory.Instance.createElement("svc-side-bar", { model: this.creator.sidebar });
        }
        else {
            return null;
        }
    };
    return SurveyCreatorComponent;
}(SurveyElementBase));
export { SurveyCreatorComponent };
var SurveyCreator = /** @class */ (function (_super) {
    __extends(SurveyCreator, _super);
    function SurveyCreator(options, options2) {
        if (options === void 0) { options = {}; }
        return _super.call(this, options, options2) || this;
    }
    SurveyCreator.prototype.render = function (target) {
        // eslint-disable-next-line no-console
        console.error("The render method is deprecated. Use SurveyCreatorComponent instead.");
    };
    //ISurveyCreator
    SurveyCreator.prototype.createQuestionElement = function (question) {
        return ReactQuestionFactory.Instance.createQuestion(question.isDefaultRendering()
            ? question.getTemplate()
            : question.getComponentName(), {
            question: question,
            isDisplayMode: question.isReadOnly,
            creator: this
        });
    };
    SurveyCreator.prototype.renderError = function (key, error, cssClasses) {
        return (React.createElement("div", { key: key },
            React.createElement("span", { className: cssClasses.error.icon, "aria-hidden": "true" }),
            React.createElement("span", { className: cssClasses.error.item },
                React.createElement(SurveyLocStringViewer, { locStr: error.locText }))));
    };
    SurveyCreator.prototype.questionTitleLocation = function () {
        return this.survey.questionTitleLocation;
    };
    SurveyCreator.prototype.questionErrorLocation = function () {
        return this.survey.questionErrorLocation;
    };
    return SurveyCreator;
}(SurveyCreatorModel));
export { SurveyCreator };
ReactElementFactory.Instance.registerElement("survey-widget", function (props) {
    return React.createElement(Survey, props);
});
